import React, { FunctionComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { bringSelectedItemsToFront } from '../../actions/annotations';

type Props = ReturnType<typeof mapDispatchToProps>;

const BringToFront: FunctionComponent<Props> = ({ bringSelectedItemsToFront }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Bring To Front">
    <div>
      <IconButton sx={{ borderRadius: 0 }} aria-label="Bring to Front" onClick={bringSelectedItemsToFront}>
        <KeyboardTabIcon sx={{ transform: 'rotate(-90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators({ bringSelectedItemsToFront }, dispatch);
}

export default connect(null, mapDispatchToProps)(BringToFront);
